import styled from "styled-components";
import { Link } from "react-router-dom";
import { Table, Button, Icon } from "semantic-ui-react";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  padding-left: 250px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.section`
  display: flex;
  flex-direction: column;
  /* width: 80%; */
  /* max-width: 1440px; */
  /* padding: 1rem; */
  height: 100%;
  width: 100%;

  /* margin-top: 40px;
  padding-bottom: 80px; */

  & > input {
    border: 1px solid #c4c4c4;
    border-radius: var(--border-radius);
    min-height: 40px;
    min-width: 450px;
    width: 100%;
    padding: 5px 5px 5px 15px;

    @media screen and (max-width: 800px) {
      min-width: 220px;
      width: 100%;
    }
  }

  & > div {
    width: 100%;

    & > input {
      width: 100%;
    }
  }

  & > *:not(:last-child) {
    margin-bottom: 48px;
  }
`;

export const Title = styled.h1`
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  padding-bottom: 10px;
`;

export const FormContainer = styled.section`
  width: max-content;
  height: max-content;
`;

export const CursosContainer = styled.section`
  width: max-content;
  height: max-content;

  & > *:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const CardsContainer = styled.div`
  color: #000;

  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  & > *:not(:last-child) {
    margin-right: 20px;
  }
`;

export const Card = styled.div`
  color: #000;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    height: 120px;
    width: 120px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: 0.3em;

    margin: 20px 0 20px 0;
    border-radius: 10px;
    border: 1px solid rgba(34, 36, 38, 0.15);
    box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);

    cursor: pointer;

    transition: transform 0.3s ease-in-out;

    &:hover {
      transform: scale(1.2);
    }

    ${(props) =>
    props.active &&
    `
      border: 3px solid #f00;
    `}
  }

  p {
    margin: 5px;
  }
`;

export const AmeIcon = styled.img`
  height: 4em;
`;

export const PaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;

  & > span {
    text-decoration: underline;
    cursor: pointer;

    & > * {
      margin-right: 24px;
    }
  }

  & > *:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const ValuesContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: max-content;

  & > div {
    width: max-content;
    margin-right: 10px;
  }
`;

export const TextValue = styled.div`
  p {
    margin-bottom: 4px;
    font-size: 20px;
  }

  input {
    border: 1px solid #c4c4c4;
    border-radius: var(--border-radius);
    min-height: 40px;
    min-width: 450px;
    width: 100%;
    padding: 5px 5px 5px 15px;
  }
`;
